import React from "react";
import { Modal, Typography } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";

interface ConfirmDangerOptions {
  title: string;
  /** 必须陈述后果(PRD v4 05§1:危险操作要说清楚会发生什么) */
  consequence: React.ReactNode;
  okText?: string;
  onOk: () => void | Promise<void>;
  onCancel?: () => void;
}

/**
 * confirmDanger 危险操作统一确认(PRD v4 12§0.4 ConfirmDanger):
 * 删除/重置/发布等不可逆操作必须经此确认并陈述后果,禁止直接 Modal.confirm 散写。
 */
export function confirmDanger({ title, consequence, okText = "确认执行", onOk, onCancel }: ConfirmDangerOptions) {
  return Modal.confirm({
    title,
    icon: <ExclamationCircleOutlined style={{ color: "#ff4d4f" }} />,
    content: (
      <Typography.Paragraph style={{ marginBottom: 0 }} type="danger">
        {consequence}
      </Typography.Paragraph>
    ),
    okText,
    okButtonProps: { danger: true },
    cancelText: "取消",
    onOk,
    onCancel,
  });
}

export default confirmDanger;
